module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "type": _vm.type,
        "size": _vm.size,
        "closable": "",
        "disable-transitions": false,
        "disabled": _vm.disabled
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag) + "\n  ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": _vm.size
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.form),
      callback: function($$v) {
        _vm.form = $$v
      },
      expression: "form"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ New " + _vm._s(_vm.tagLabel))])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ebae984"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/inputs/TagInput.vue
// module id = 1323
// module chunks = 0